import type { SVGProps } from 'react';
import { memo } from 'react';

import { SVG_STOROKE_SIZE } from '@/data/shared/constant';

import { IconSizeType } from '@/types/icon';

interface SvgIconProps extends SVGProps<SVGSVGElement> {
  size: IconSizeType;
}
const SvgIconBasketShoppingSharpLine = ({
  size = 24,
  ...props
}: SvgIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill="none"
    viewBox="0 0 24 24"
    className="svgr-icon-component"
    strokeWidth={SVG_STOROKE_SIZE[size]}
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="m10.763 4.791-.597.802-2.608 3.502h8.89l-2.607-3.502-.598-.802 1.604-1.194.598.802 3.497 4.696H22v2h-1.51l-2.093 8.546-.187.762H5.784l-.186-.763-2.08-8.545H2v-2h3.064L8.562 4.4l.597-.802 1.604 1.194Zm7.175 6.304.025.034.046-.034h.422l-1.79 7.308H7.355l-1.779-7.308h.42l.047.034.025-.034h11.87Z"
      clipRule="evenodd"
    />
  </svg>
);
const Memo = memo(SvgIconBasketShoppingSharpLine);
export default Memo;
